import serviceInterface from '../../services/service.interface'
import { message } from 'antd'

// Load the clinic's saved default care plan + the catalogs for the pickers.
// Resolves with the payload even on a "not linked" status so the form can show
// an alert; the component inspects data.status / data.message.
export function fetchDefaultCarePlan({ customerid, companyid, surgeryType }) {
  return async () => {
    try {
      const data = await serviceInterface
        .DefaultCarePlanService()
        .getDefaultCarePlan({ customerid, companyid, surgeryType })
      return data
    } catch (err) {
      console.log(err)
      return { error: true }
    }
  }
}

// Persist the full selection to the three clinic templates (surgery.feedback,
// the wildcard regimen, the active careplan). Toasts on success/failure.
export function saveDefaultCarePlan({ customerid, companyid, surgeryType, feedback, exercises, devices }) {
  return async () => {
    try {
      const data = await serviceInterface
        .DefaultCarePlanService()
        .updateDefaultCarePlan({ customerid, companyid, surgeryType, feedback, exercises, devices })
      message.success('Default care plan saved')
      return data
    } catch (err) {
      console.log(err)
      message.error((err && err.message) || 'Failed to save default care plan')
      return { error: true }
    }
  }
}

// Clinic Settings "Reset to company care plan": one call replaces the clinic's
// templates, TracPatch settings, Progress Test Goals and reminders with the
// company's current ones. Toasts the server's message on success. Resolves
// { error: true } on failure so the page can leave its panels as they are.
export function resetClinicToCompanyCarePlan({ customerid }) {
  return async () => {
    try {
      const data = await serviceInterface
        .DefaultCarePlanService()
        .resetToCompanyCarePlan({ customerid })
      message.success((data && data.message) || 'Clinic reset to the company care plan')
      return data
    } catch (err) {
      console.log(err)
      message.error((err && err.message) || 'Failed to reset to the company care plan')
      return { error: true }
    }
  }
}

// The care-plan panel's own Reset: one surgery type back to the company plan.
export function resetClinicCarePlan({ customerid, surgeryType }) {
  return async () => {
    try {
      const data = await serviceInterface
        .DefaultCarePlanService()
        .resetClinicCarePlan({ customerid, surgeryType })
      message.success((data && data.message) || 'Care plan reset to the company plan')
      return data
    } catch (err) {
      console.log(err)
      message.error((err && err.message) || 'Failed to reset the care plan')
      return { error: true }
    }
  }
}
